var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
var HotspotContext = createContext(undefined);
export var HotspotProvider = function (_a) {
    var children = _a.children;
    var _b = useState([]), hotspots = _b[0], setHotspots = _b[1];
    var updateHotspot = function (name, x, y, screenX, screenY) {
        setHotspots(function (prevHotspots) {
            var existingHotspot = prevHotspots.find(function (hotspot) { return hotspot.name === name; });
            if (existingHotspot) {
                // Met à jour l'existant
                return prevHotspots.map(function (hotspot) {
                    return hotspot.name === name ? __assign(__assign({}, hotspot), { XPosition: x, YPosition: y, screenX: screenX, screenY: screenY }) : hotspot;
                });
            }
            else {
                // Ajoute un nouveau hotspot
                return __spreadArray(__spreadArray([], prevHotspots, true), [{ name: name, XPosition: x, YPosition: y, screenX: screenX, screenY: screenY }], false);
            }
        });
    };
    var resetHotspots = function () {
        console.log("[HotspotContext] resetHotspots @".concat(Date.now()));
        setHotspots([]);
    };
    return (_jsx(HotspotContext.Provider, __assign({ value: { hotspots: hotspots, updateHotspot: updateHotspot, resetHotspots: resetHotspots } }, { children: children })));
};
export var useHotspot = function () {
    var context = useContext(HotspotContext);
    if (!context) {
        throw new Error('useHotspot must be used within a HotspotProvider');
    }
    return context;
};
